import { render, staticRenderFns } from "./AddNewApplicant.vue?vue&type=template&id=2ab196c2&scoped=true"
import script from "./AddNewApplicant.vue?vue&type=script&lang=js"
export * from "./AddNewApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab196c2",
  null
  
)

export default component.exports